import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Order, Language } from "../../../../../../../services";
import { useTypedSelector } from "../../../../../../../redux/store";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const PaymentStatusCellContent: React.FC<PaymentStatusCellContent.Props> = ({
	item,
	language,
}) => {
	const { t } = useTranslation();
	const colors = useTypedSelector((state) => state.settings.colors);

	const { content, backgroundColor, textColor } = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const isLanguageMatched =
			item?.cellsForTableSettings?.lang === language;

		const preparedCell = item?.cellsForTable?.[ColumnId.PaymentStatus];

		if (isCellsReady && isLanguageMatched && preparedCell != null) {
			return preparedCell;
		}

		return cellProcessing(item, t, colors);
	}, [colors, item, language, t]);

	return (
		<CellContentRoot
			alignItems="center"
			h="100%"
			w="100%"
			backgroundColor={backgroundColor}
			textColor={textColor}
		>
			{content}
		</CellContentRoot>
	);
};

declare namespace PaymentStatusCellContent {
	interface Props {
		item: Order.Model;
		language: Language;
	}
}

export default PaymentStatusCellContent;
